import { render, staticRenderFns } from "./OtpCheck.vue?vue&type=template&id=7c8e03ce&"
import script from "./OtpCheck.vue?vue&type=script&lang=js&"
export * from "./OtpCheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports